export const hourlyCalendar = {
  title: "التقويم بالساعة",
  navSubtitle: "البيع بالساعة لفندقك",
  hotel: "الفندق",
  rooms: "الغرف",
  roomsAbbr: "غرف",
  noDisp: "غير متاح",
  footer: {
    free: "{n} متاحة",
    occupied: "{n} مشغولة",
    cleaning: "{n} قيد التنظيف",
    timezone: "المنطقة الزمنية: {tz}",
  },
  today: "اليوم",
  prevDay: "اليوم السابق",
  nextDay: "اليوم التالي",
  newStay: "إقامة جديدة",
  settingsBtn: "إعدادات البيع بالساعة",
  retry: "إعادة المحاولة",
  dragHint: "اسحب على غرفة لإنشاء إقامة",
  groupFree: "{free} من {total} متاحة",
  zoom: { label: "التكبير", compact: "مضغوط", normal: "عادي", wide: "واسع" },
  duration: { min: "{n} د", h: "{n} س", hmin: "{h} س {m} د" },
  kpi: {
    free: "متاحة الآن",
    occupied: "مشغولة",
    cleaning: "قيد التنظيف",
    arrivals: "تصل خلال ساعة",
    overdueAlert: "غرفة واحدة تجاوزت موعدها | {n} غرف تجاوزت موعدها",
  },
  state: {
    free: "متاحة",
    freeNext: "متاحة · التالية {time}",
    soon: "تصل الساعة {time}",
    occupied: "مشغولة",
    occupiedLeft: "مشغولة · متبقٍ {time}",
    overdue: "تجاوزت {time}",
    due: "بانتظار الدخول",
    cleaning: "تنظيف · {time}",
    closed: "مغلقة",
    maintenance: "خارج الخدمة",
  },
  status: {
    booked: "محجوزة",
    in_house: "جارية",
    checked_out: "منتهية",
    cancelled: "ملغاة",
    no_show: "لم يحضر",
  },
  block: {
    noName: "بدون اسم",
    blocked: "محجوبة",
    night: "ليلة",
    closed: "مغلقة",
    maintenance: "خارج الخدمة",
    left: "متبقٍ {time}",
  },
  legend: {
    booked: "محجوزة",
    inHouse: "جارية",
    overdue: "تجاوزت الموعد",
    cleaning: "تنظيف",
    night: "حجز بالليلة",
    closed: "مغلقة",
  },
  rangeMenu: {
    create: "إنشاء إقامة",
    createSub: "في الوقت المحدد",
    block: "حجب هذا الوقت",
    blockSub: "لن تُباع الغرفة في هذه الفترة",
    closeDay: "إغلاق الغرفة طوال اليوم",
    closeDaySub: "لن تُباع هذه الغرفة ذلك اليوم",
  },
  blockMenu: {
    editReason: "تغيير السبب",
    editReasonSub: "يظهر في التقويم",
    remove: "إزالة الحجب",
    removeSub: "تعود الغرفة للبيع",
  },
  blockModal: {
    titleRange: "حجب هذا الوقت",
    titleDay: "إغلاق الغرفة",
    titleEdit: "سبب الحجب",
    msgRange: "لن تُباع {room} من {range}.",
    msgDay: "لن تُباع {room} في {date}.",
    msgDayRest: "لن تُباع {room} بقية اليوم (اعتبارًا من {time}).",
    msgEdit: "{room}",
    reasonLabel: "السبب",
    reasonHint: "(يظهر في التقويم)",
    placeholder: "صيانة، استخدام خاص…",
    cancel: "إلغاء",
    block: "حجب",
    save: "حفظ",
    presetMaintenance: "صيانة",
    presetOwner: "استخدام المالك",
    presetRepair: "تجديد",
    presetDeepClean: "تنظيف عميق",
    presetClosed: "مغلقة",
  },
  drawer: {
    close: "إغلاق",
    closeBtn: "إغلاق",
    newTitle: "إقامة جديدة",
    newPill: "جديدة",
    when: "متى",
    room: "الغرفة",
    start: "الدخول",
    end: "الخروج",
    nextDay: "اليوم التالي",
    duration: "المدة",
    other: "أخرى",
    free: "الغرفة متاحة في هذا الوقت",
    freeWithCleaning: "متاحة · يُحجز {n} دقيقة للتنظيف بعد المغادرة",
    freeWillClose: "متاحة · ثم تبقى مغلقة حتى {hour}",
    busy: "مشغولة من {from} إلى {to}",
    busyClosed: "مغلقة من {from} إلى {to}",
    busyMaintenance: "الغرفة خارج الخدمة",
    guest: "العميل",
    guestName: "الاسم",
    phone: "الهاتف",
    optional: "اختياري",
    guests: "الأشخاص",
    charge: "الدفع",
    price: "السعر",
    method: "طريقة الدفع",
    methods: { cash: "نقدًا", card: "بطاقة", transfer: "تحويل", other: "أخرى" },
    paid: "تم التحصيل",
    paidHint: "لقد استلمت بالفعل مبلغ هذه الإقامة.",
    notes: "ملاحظات",
    notesPh: "رقم اللوحة، الطلبات، أي شيء مفيد",
    guestTitle: "تسجيل النزيل",
    sendCheckin: "إرسال رابط تسجيل الوصول",
    sendCheckinHint: "يُرسل عند الحفظ إلى هاتف النزيل.",
    sendCheckinNoPhone: "اكتب هاتف النزيل لتتمكن من إرسال تسجيل الوصول إليه.",
    doCheckin: "إجراء تسجيل الوصول",
    edit: "تعديل",
    client: "النزيل",
    paidYes: "مدفوع",
    paidNo: "غير مدفوع",
    markPaid: "وضع علامة مدفوع",
    doCheckinHint: "افتحه على هاتف النزيل أو أرسل له الرابط: الاسم واللقب والوثيقة، مع المسح إن أراد.",
    copyLink: "نسخ الرابط",
    copied: "نُسخ الرابط",
    checkinDone: "تم تسجيل الوصول · سُجّل {n} نزيل | تم تسجيل الوصول · سُجّل {n} نزلاء",
    checkinErrors: {
      no_reservation: "فعّل «تسجيل الإقامات كحجوزات» في الإعدادات لتتمكن من طلب تسجيل الوصول.",
      no_phone: "اكتب هاتف النزيل لتتمكن من إرساله إليه.",
      send_failed: "تعذّر الإرسال. جرّب نسخ الرابط وإرساله بنفسك.",
      not_requested: "تعذّر الإرسال. جرّب نسخ الرابط وإرساله بنفسك.",
    },
    checkinSent: "أُرسل تسجيل الوصول",
    sendCheckinFailed: "تعذّر إرسال تسجيل الوصول. تحقّق من هاتف النزيل.",
    save: "حفظ",
    saveAndIn: "حفظ وتسجيل الدخول",
    saveChanges: "حفظ التغييرات",
    checkIn: "تسجيل الدخول",
    checkOut: "تسجيل الخروج",
    extend30: "30 د",
    extend60: "ساعة",
    extendOther: "آخر",
    extendHow: "تمديد",
    extendApply: "تمديد",
    cancelBtn: "إلغاء",
    checkOutNotYet: "يمكن تسجيل المغادرة عند بدء الإقامة",
    confirmEarlyOutTitle: "لم تبدأ الإقامة بعد",
    confirmEarlyOut: "تبدأ هذه الإقامة لاحقًا. تسجيل المغادرة الآن يغلقها ويحرر الغرفة. إذا لم يحضر النزيل، استخدم «لم يحضر».",
    noShow: "لم يحضر",
    cancelStay: "إلغاء الإقامة",
    keep: "رجوع",
    confirmCancel: "تُلغى وتبقى الغرفة حرة في ذلك الوقت. لا يمكن التراجع.",
    confirmNoShow: "تعود الفترة متاحة للبيع. ويُسجَّل أن النزيل لم يأتِ.",
    confirmNoShowInHouse: "كان مسجّلًا بالداخل لكنه لم يصعد: يُلغى الدخول وتعود الفترة حرة.",
    confirmCancelInHouse: "كان مسجّلًا بالداخل: يُلغى الدخول وتُلغى الإقامة وتبقى الغرفة حرة. لا يمكن التراجع.",
    confirmNoShowTitle: "لم يحضر؟",
    confirmCancelTitle: "إلغاء الإقامة؟",
    remaining: "متبقٍ {time}",
    overdue: "تجاوزت موعدها بـ {time}",
    startsIn: "تبدأ بعد {time}",
    waiting: "بدأ موعدها: بانتظار الدخول",
    closedInfo: "إقامة مغلقة: يمكن تعديل الدفع والملاحظات فقط.",
    night: {
      title: "حجز بالليالي",
      dates: "من {from} إلى {to}",
      code: "الرمز",
      channel: "القناة",
      hint: "تُدار الحجوزات بالليالي من تقويم الفندق. تظهر هنا حتى لا تتداخل معها أي إقامة بالساعة.",
      open: "الانتقال إلى تقويم الفندق",
    },
  },
  settings: {
    title: "البيع بالساعة",
    enable: "البيع بالساعة",
    subtitle: "كيف يبيع هذا الفندق بالساعة",
    offTitle: "إذا أوقفته",
    offBody: "لن يعود التقويم بالساعة متاحًا وسيعمل الفندق كالمعتاد. لا يُحذف شيء.",
    offBodyStays: "لديك {n} إقامات بالساعة قادمة: لا تُحذف، لكنك لن تراها حتى تعيد التفعيل.",
    enabledOn: "مفعّل: التقويم بالساعة قيد الاستخدام",
    enabledOff: "غير مفعّل",
    requirements: "المتطلبات",
    req: {
      rooms: "الغرف المُنشأة ({n})",
      channels: "لا توجد قنوات بيع متصلة",
      ical: "لا توجد تقويمات iCal متزامنة",
      web: "الحجز عبر الموقع معطّل",
      nights: "{n} حجوزات بالليالي قادمة: ستظهر في التقويم وتحجب غرفها",
    },
    reqWhy: "القنوات وiCal والموقع تبيع ليالي ولا تعرف شيئًا عن الساعات: مع تفعيل أي منها قد تُباع الغرفة نفسها مرتين.",
    cleaning: "التنظيف بين الإقامات",
    cleaningHint: "يُحجز تلقائيًا بعد كل خروج.",
    pending: "بانتظار التنظيف",
    pendingHint: "عند خروج النزيل تبقى الغرفة معلَّمة «بحاجة للتنظيف» في قسم التنظيف وفي التطبيق طوال هذه المدة. لا يوقف ذلك البيع: إذا دخل أحد قبل ذلك، تُنظَّف حينها.",
    none: "بدون",
    minutes: "دقيقة",
    hours: "س",
    closeTitle: "الإغلاق حتى ساعة الفتح",
    closeHint: "لمّا لا تُنظَّف الغرفة فورًا: تبقى مغلقة ولا يستطيع أحد بيعها حتى تفتحها.",
    closeAfterStay: "عند انتهاء الإقامة، اترك الغرفة مغلقة",
    closeAfterStayHint: "تُغلق وحدها حتى ساعة الفتح في اليوم التالي. وإن نظّفتها قبل ذلك، اضغط «أصبحت نظيفة» فتعود للبيع فورًا.",
    afterTitle: "بعد كل إقامة",
    afterHint: "كم من الوقت تتوقف الغرفة عن البيع عند مغادرة النزيل.",
    untilOpening: "حتى الفتح",
    reopenHour: "ساعة فتح البيع",
    reopenNote: "تعود الغرف المتسخة إلى البيع في {hour}.",
    markClean: "أصبحت نظيفة",
    markCleanHint: "تفتح الغرفة الآن دون انتظار ساعة الفتح.",
    closeThisStay: "اترك الغرفة مغلقة عند الانتهاء",
    closeThisStayHint: "لن يمكن بيعها حتى {hour}. تُغيَّر الساعة في الإعدادات.",
    dayStart: "بداية يوم التقويم",
    dayRange: "من {from} إلى {from} في اليوم التالي",
    dayStartHint: "اختر الساعة الأقل حركة: هكذا تظهر الليلة كاملة.",
    quickHours: "مدد سريعة",
    quickHoursHint: "تظهر كاختصارات عند إنشاء إقامة (حتى 6).",
    guestTitle: "تسجيل النزيل",
    asReservation: "تسجيل الإقامات كحجوزات",
    asReservationHint: "كل إقامة تُنشئ حجزها: هكذا يظهر المال في تقاريرك ويمكنك طلب تسجيل الوصول وبيانات النزلاء. إذا أوقفته، لن تُحتسب مبيعات الساعات ضمن إيراداتك.",
    checkinDefault: "طلب تسجيل الوصول افتراضيًا",
    checkinDefaultHint: "سيأتي المفتاح في بطاقة الإقامة مفعّلًا.",
    guestHint: "هذه الحجوزات لا تتلقى الرسائل المخصصة لليالي (الترحيب والوصول والمغادرة والتقييم): يُرسل رابط تسجيل الوصول عندما تطلبه أنت.",
    save: "حفظ الإعدادات",
    saved: "تم حفظ الإعدادات",
  },
  empty: {
    eyebrow: "البيع بالساعة",
    title: "بِع غرفك بالساعة",
    body: "تقويم مصمم للموتيلات والفنادق ذات الإقامات القصيرة: ترى كل غرفة بالدقيقة، وتنشئ الإقامات بالسحب، ويُحجز التنظيف بين إقامة وأخرى تلقائيًا.",
    point1: "حالة كل غرفة في الوقت الفعلي",
    point2: "اسحب لإنشاء الإقامات أو نقلها أو تمديدها",
    point3: "تنظيف تلقائي بين الإقامات",
    cta: "تفعيل البيع بالساعة",
    ctaBlocked: "أكمل المتطلبات لتفعيله",
    noHotelsTitle: "ليس لديك فندق بعد",
    noHotels: "يعمل البيع بالساعة مع أماكن الإقامة من نوع فندق التي لديها غرف مُنشأة.",
  },
  guide: {
    open: "دليل الاستخدام",
    title: "كيف يعمل التقويم بالساعات",
    subtitle: "الأساسيات في دقيقة: إنشاء الإقامات، تسجيل الدخول والخروج، وإغلاق الغرف التي لا تبيعها.",
    createTitle: "إنشاء إقامة",
    createBody: "اسحب على صف الغرفة من ساعة الدخول إلى ساعة الخروج. ويمكنك أيضًا الضغط على «إقامة جديدة» وكتابة الساعات يدويًا.",
    moveTitle: "النقل والتمديد",
    moveBody: "اسحب الشريط لتغيير الساعة أو الغرفة. واسحب الحافة اليمنى لتطويل الإقامة أو تقصيرها. وإذا كان الوقت محجوزًا فلن يسمح لك التقويم بإفلاته.",
    checkinTitle: "الدخول والخروج",
    checkinBody: "افتح الإقامة وسجّل الدخول عند وصول النزيل والخروج عند مغادرته. وإذا تجاوز الوقت يتحول الشريط إلى الأحمر مع الدقائق الزائدة.",
    cleaningTitle: "التنظيف بين إقامة وأخرى",
    cleaningBody: "بعد كل خروج تُحجز تلقائيًا فترة التنظيف التي حدّدتها، ولا يمكن لأحد الدخول خلالها.",
    blockTitle: "حجب وقت أو إغلاق الغرفة",
    blockBody: "حدّد فترة واختر «احجب هذا الوقت»، أو «أغلق الغرفة طوال اليوم» إذا كنت لن تبيعها ذلك اليوم. واضغط على الحجب لتغيير سببه أو إزالته.",
    settingsTitle: "الإعدادات",
    settingsBody: "من الترس تضبط وقت التنظيف، والساعة التي يبدأ عندها يوم التقويم، والمدد السريعة التي تظهر عند إنشاء إقامة.",
    colorsTitle: "معنى كل لون",
    colors: {
      booked: "أُنشئت ولم يدخل النزيل بعد",
      inHouse: "النزيل داخل الغرفة",
      overdue: "تجاوز وقت الخروج",
      cleaning: "فترة محجوزة للتنظيف",
      night: "قادمة من تقويم الليالي",
      closed: "محجوبة أو مغلقة يدويًا",
    },
    otasTitle: "حجوزات الليالي والقنوات",
    otasBody: "تظهر حجوزات الليالي هنا لتعرف الغرف المشغولة، لكن تُدار من تقويم الفندق. وما دمت تبيع بالساعة فلن يرتبط هذا المسكن بمنصات الحجز.",
    gotIt: "فهمت",
  },
  toasts: {
    created: "تم إنشاء الإقامة",
    checkedIn: "تم تسجيل الدخول",
    checkedOut: "تم تسجيل الخروج · بدأ التنظيف",
    updated: "تم حفظ التغييرات",
    extended: "تم تمديد الإقامة",
    cancelled: "تم إلغاء الإقامة",
    noShow: "تم تعليمها كعدم حضور",
    moved: "تم نقل الإقامة",
    resized: "تم تحديث المدة",
    activated: "تم تفعيل البيع بالساعة",
    blocked: "تم حجب الوقت",
    blockUpdated: "تم تحديث السبب",
    blockRemoved: "تمت إزالة الحجب",
    loadError: "تعذّر تحميل التقويم بالساعة",
    error: "تعذّر الحفظ. حاول مرة أخرى.",
  },
  errors: {
    room_busy: "الغرفة مشغولة من {from} إلى {to}",
    hourly_disabled: "البيع بالساعة غير مفعّل في هذا الفندق.",
    room_maintenance: "هذه الغرفة خارج الخدمة.",
    room_not_found: "هذه الغرفة لا تتبع هذا الفندق.",
    invalid_duration: "يجب أن تكون المدة بين 30 دقيقة و48 ساعة.",
    invalid_start: "وقت الدخول غير صالح.",
    stay_closed: "هذه الإقامة مغلقة: لا يمكن نقلها.",
    invalid_status: "هذا الإجراء غير متاح في حالة الإقامة الحالية.",
    requirements_not_met: "هذا الفندق لا يستوفي بعد متطلبات البيع بالساعة.",
    not_found: "لم يتم العثور على العنصر. أعد تحميل الصفحة.",
    generic: "حدث خطأ ما. حاول مرة أخرى.",
  },
};
